import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsIllustration/SdsIllustration.vue.js';

var script = defineComponent({
    name: 'SdsEmptyScreen',
    props: {
        illustrationName: {
            type: String,
            required: false,
            default: '',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        description: {
            type: String,
            required: false,
            default: '',
        },
        background: {
            type: String,
            required: false,
            default: 'elevation',
        },
    },
    emits: [
        'click:primary',
        'click:secondary',
    ],
    setup: function (props, _a) {
        var emit = _a.emit, slots = _a.slots;
        // These needs to be declared statically, otherwise they get recomputed all the time
        var primaryActionAttrs = {
            size: 'md',
            variant: 'primary',
            'data-action': 'primary',
        };
        var primaryActionHandlers = {
            click: function () { return emit('click:primary'); },
        };
        var secondaryActionAttrs = {
            size: 'md',
            variant: 'secondary',
            'data-action': 'secondary',
        };
        var secondaryActionHandlers = {
            click: function () { return emit('click:secondary'); },
        };
        var hasDescription = computed(function () {
            return props.description || slots['description'];
        });
        var hasActions = computed(function () {
            return slots['primary-action'] || slots['secondary-action'];
        });
        return {
            hasActions: hasActions,
            hasDescription: hasDescription,
            primaryActionAttrs: primaryActionAttrs,
            primaryActionHandlers: primaryActionHandlers,
            secondaryActionAttrs: secondaryActionAttrs,
            secondaryActionHandlers: secondaryActionHandlers,
        };
    },
    components: {
        SdsIllustration: __vue_component__,
    },
});

export default script;
